import { render, staticRenderFns } from "./SToggle.vue?vue&type=template&id=087ecfa1&scoped=true&"
import script from "./SToggle.vue?vue&type=script&lang=js&"
export * from "./SToggle.vue?vue&type=script&lang=js&"
import style0 from "./SToggle.vue?vue&type=style&index=0&id=087ecfa1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ecfa1",
  null
  
)

export default component.exports